







































































import { apiService, AppConstants, Interfaces, Models } from "@/core/Export";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class EmployeeAttendDayApprove extends Vue {
  dayPairs: Array<Models.EAME_PairDto>;
  notes: string;
  approveRejectOptions: Array<any>;
  isReject: boolean;
  constructor() {
    super();
    this.dayPairs = new Array<Models.EAME_PairDto>();
    this.notes = null;
    this.approveRejectOptions = new Array<any>();
    this.isReject = false;
  }

  created() {
    this.onFilleApproveRejectOptions();
    this.onGetEmployeeAttendDayApprove();
  }

  @Watch("drawerParams")
  @Watch("selectedYear")
  @Watch("selectedMonth")
  onGetEmployeeAttendDayApprove() {
    this.appEnv.isBusy = true;
    apiService
      .getEmployeeAttendDayApprove(
        this.drawerParams.date,
        this.currentEmployee.id,
        this.selectedYear,
        this.selectedMonth,
        this.currentEmployee.salaryFactoryNo,
        this.selectedEmpNominationId
      )
      .then(res => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          this.dayPairs = call.callResult.data as Array<Models.EAME_PairDto>;
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
        }
        this.appEnv.isBusy = false;
      })
      .catch(err => {
        this.appEnv.isBusy = false;
      });
  }

  onSaveEmployeeAttendDayApprove(e) {
    e.preventDefault();
    let employeeAttendDayApproveForm = this.$refs
      .employeeAttendDayApproveForm as any;
    employeeAttendDayApproveForm.validate().then(success => {
      if (success) {
        this.saveEmployeeAttendDayApprove();
      }
    });
  }

  saveEmployeeAttendDayApprove() {
    this.appEnv.isBusy = true;
    apiService
      .saveEmployeeAttendDayApprove(
        this.drawerParams.date,
        this.currentEmployee.id,
        this.isReject,
        this.notes,
        this.selectedYear,
        this.selectedMonth,
        this.currentEmployee.salaryFactoryNo,
        this.selectedEmpNominationId
      )
      .then(res => {
        let result: Interfaces.iServiceRequest = res;
        let call = result.calls[0] as Interfaces.iServiceCall;
        if (call && call.isSuccess) {
          store
            .dispatch(AppConstants.StoreActions.GetEmployeeMonthAttendViewData, {
              forceCalc: true,
            })
            .finally(() => {
              this.onCloseEmployeeAttendDayApproveDrawer();
              this.appEnv.isBusy = false;
            });
        } else {
          this.appEnv.showErrorDialog(call.msgs.msgs);
          this.appEnv.isBusy = false;
        }
      })
      .catch(err => {
        this.appEnv.isBusy = false;
      });
  }

  onIsRejectChanged(e) {
    let notesInput = this.$refs.notes as any;
    if (notesInput) {
      notesInput.validate();
    }
  }

  hasNotesError(value) {
    return !(this.isReject && !value);
  }

  onFilleApproveRejectOptions() {
    this.approveRejectOptions.push({ value: true, label: this.$t("reject") });
    this.approveRejectOptions.push({ value: false, label: this.$t("approve") });
  }

  onCloseEmployeeAttendDayApproveDrawer() {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, false);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, null);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, {});
  }

  set employeeAttendViewData(value) {
    store.commit(
      AppConstants.StoreMutations.UpdateEmployeeAttendViewData,
      value
    );
  }

  get selectedEmpNominationId() {
    return store.getters.selectedEmpNominationId;
  }

  get canEditMonth() {
    return store.getters.canEditMonth;
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get drawerParams() {
    return store.getters.drawerParams;
  }

  get selectedYear() {
    return store.getters.selectedYear;
  }

  get selectedMonth() {
    return store.getters.selectedMonth;
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
